import api from './api';

export const integrationKeyService = {
  list:     (facilityId) => api.get('/bridge/keys', { params: facilityId ? { facilityId } : {} }),
  generate: (payload)    => api.post('/bridge/keys', payload),
  rotate:   (id, payload) => api.post(`/bridge/keys/${id}/rotate`, payload || {}),
  revoke:   (id)         => api.delete(`/bridge/keys/${id}`),
};
